"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require("react-bootstrap");

var _styled = require("./styled.footer");

var _reactRouterDom = require("react-router-dom");

var _inlineDiv = require("../../../inlineDiv");

var _inlineDiv2 = _interopRequireDefault(_inlineDiv);

var _defaultProps = require("./defaultProps");

var _defaultProps2 = _interopRequireDefault(_defaultProps);

var _baseHelper = require("../../../helper/baseHelper");

var _baseHelper2 = _interopRequireDefault(_baseHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPropValue = _baseHelper2.default.getPropValue;


var Footer = function Footer(props) {
  var newProps = _extends({}, _defaultProps2.default.props, props);
  var content = newProps.content,
      isEditMode = newProps.isEditMode,
      media = newProps.media,
      setData = newProps.setData,
      style = newProps.style,
      updateProps = newProps.updateProps;


  var socialIconsURL = {
    facebookURL: media.facebookURL,
    youTubeURL: media.youTubeURL,
    twitterURL: media.twitterURL,
    googleURL: media.googleURL
  };

  var column_1_title = {
    column_1_title_1: content.column_1_title_1,
    column_1_title_2: content.column_1_title_2,
    column_1_title_3: content.column_1_title_3,
    column_1_title_4: content.column_1_title_4
  };
  var column_1_url = {
    column_1_url_1: media.column_1_url_1,
    column_1_url_2: media.column_1_url_2,
    column_1_url_3: media.column_1_url_3,
    column_1_url_4: media.column_1_url_4
  };
  var column_2_title = {
    column_2_title_1: content.column_2_title_1,
    column_2_title_2: content.column_2_title_2,
    column_2_title_3: content.column_2_title_3,
    column_2_title_4: content.column_2_title_4
  };
  var column_2_url = {
    column_2_url_1: media.column_2_url_1,
    column_2_url_2: media.column_2_url_2,
    column_2_url_3: media.column_2_url_3,
    column_2_url_4: media.column_2_url_4
  };
  var column_3_title = {
    column_3_title_1: content.column_3_title_1,
    column_3_title_2: content.column_3_title_2,
    column_3_title_3: content.column_3_title_3,
    column_3_title_4: content.column_3_title_4
  };
  var column_3_url = {
    column_3_url_1: media.column_3_url_1,
    column_3_url_2: media.column_3_url_2,
    column_3_url_3: media.column_3_url_3,
    column_3_url_4: media.column_3_url_4
  };

  var getLineComponent = function getLineComponent(prefix, column_n_title, column_n_url) {
    var linksStyle = {
      hoverColor: getPropValue("text", "hoverColor", style.hoverColor, "style"),
      fontSize: getPropValue("text", "fontSize", style.fontSize, "style"),
      textTransform: getPropValue("text", "textTransform", style.textTransform, "style"),
      linkColor: getPropValue("text", "linkColor", style.linkColor, "style"),
      fontWeight: getPropValue("text", "fontWeight", style.fontWeight, "style")
    };

    var lineComponents = [];
    var limit = Object.keys(column_n_title).length + 1;
    for (var index = 1; index < limit; index++) {
      var title = getPropValue("text", prefix + "_title_" + index, column_n_title[prefix + "_title_" + index]);
      var url = getPropValue("text", prefix + "_url_" + index, column_n_url[prefix + "_url_" + index]);
      lineComponents.push(_react2.default.createElement(
        _styled.StyledLink,
        _extends({ className: "mb-1" }, linksStyle),
        _react2.default.createElement(
          "span",
          { key: index },
          _react2.default.createElement(_inlineDiv2.default, {
            isEditMode: isEditMode,
            keyProperty: prefix + "_title_" + index,
            property: "content",
            setData: setData,
            updateProps: updateProps,
            value: title
          })
        )
      ));
    }
    return lineComponents;
  };

  var getSocialLinks = function getSocialLinks() {
    var iconColor = getPropValue("text", "iconColor", style.iconColor, "style");
    var radius = getPropValue("text", "radius", style.radius, "style");
    var fontSize = getPropValue("text", "fontSize", style.fontSize, "style");
    var borderColor = getPropValue("text", "borderColor", style.borderColor, "style");
    var iconHoverColor = getPropValue("text", "iconHoverColor", style.iconHoverColor, "style");
    var hoverBorderColor = getPropValue("text", "hoverBorderColor", style.hoverBorderColor, "style");
    var socialIconsTitle = {
      facebookTitle: "F",
      youTubeTitle: "Y",
      twitterTitle: "T",
      googleTitle: "G+"
    };
    var returnElement = [];
    for (var item in socialIconsTitle) {
      var key = item.substring(item.length - 5, 0);
      var title = getPropValue("text", item, socialIconsTitle[item]);
      var url = socialIconsURL[key + "URL"];
      returnElement.push(_react2.default.createElement(
        _styled.SocialIcons,
        {
          key: Math.random() + "socialIcons",
          target: "_blank",
          href: url,
          iconColor: iconColor,
          radius: radius,
          fontSize: fontSize,
          borderColor: borderColor,
          iconHoverColor: iconHoverColor,
          hoverBorderColor: hoverBorderColor
        },
        title
      ));
    }
    return returnElement;
  };

  var column1 = getLineComponent("column_1", column_1_title, column_1_url);
  var column2 = getLineComponent("column_2", column_2_title, column_2_url);
  var column3 = getLineComponent("column_3", column_3_title, column_3_url);
  var socialLinks = getSocialLinks();

  var brandName = getPropValue("text", "brandName", content.brandName, "content");
  var copyRight = getPropValue("text", "copyRight", content.copyRight, "content");
  var footerStyle = {
    footerBgColor: getPropValue("text", "footerBgColor", style.footerBgColor, "style")
  };
  // const textAlign = getPropValue("text", "textAlign", style.textAlign, "style");

  return _react2.default.createElement(
    _styled.StyledFooter,
    _extends({ className: "footer" }, footerStyle),
    _react2.default.createElement(
      _reactBootstrap.Container,
      { className: "footer-container" },
      _react2.default.createElement(
        _reactRouterDom.BrowserRouter,
        null,
        _react2.default.createElement(
          _reactRouterDom.Switch,
          null,
          _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
              _reactBootstrap.Row,
              null,
              _react2.default.createElement(
                _reactBootstrap.Col,
                {
                  sm: 3,
                  className: "pt-2 text-center text-md-left mb-4 mb-sm-0"
                },
                _react2.default.createElement(
                  "h4",
                  { className: "footer-logo font-weight-bold text-uppercase d-block" },
                  _react2.default.createElement(_inlineDiv2.default, {
                    isEditMode: isEditMode,
                    keyProperty: "brandName",
                    property: "content",
                    setData: setData,
                    updateProps: updateProps,
                    value: brandName
                  })
                ),
                _react2.default.createElement(
                  "span",
                  null,
                  "Designed by Marketcube.io"
                )
              ),
              _react2.default.createElement(
                _styled.StyledCol,
                { className: "footer-box col-sm-3" },
                column1
              ),
              _react2.default.createElement(
                _styled.StyledCol,
                { className: "footer-box col-sm-3" },
                column2
              ),
              _react2.default.createElement(
                _styled.StyledCol,
                { className: "footer-box col-sm-3" },
                column3
              )
            )
          )
        )
      ),
      _react2.default.createElement(
        _styled.FooterBottom,
        null,
        socialLinks,
        _react2.default.createElement(
          "div",
          { className: "text-center copyright mt-3" },
          " ",
          _react2.default.createElement(_inlineDiv2.default, {
            isEditMode: isEditMode,
            keyProperty: "copyRight",
            property: "content",
            setData: setData,
            updateProps: updateProps,
            value: copyRight
          })
        )
      )
    )
  );
};
exports.default = Footer;